import React, { useState } from 'react';
import { Form, Input, Button, Divider, Typography, Select, message } from 'antd';
import './Registerimage.css';
import firebase from 'firebase/compat/app';
import 'firebase/compat/storage';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';


const { Option } = Select;
//app
// Initialize 
// const firebaseConfig = {
//   apiKey: "AIzaSyAWXK0vQ2LpcxG_eAD6rB2eMGtV9USDcbs",
//   authDomain: "symposium-7cf30.firebaseapp.com",
//   databaseURL: "gs://symposium-7cf30.appspot.com",
//   projectId: "symposium-7cf30",
//   storageBucket: "symposium-7cf30.appspot.com",
//   messagingSenderId: "960380894767",
//   appId: "1:960380894767:web:f8bca29a83f708963850da"
// };
const firebaseConfig = {
  apiKey: "AIzaSyBbV7jlaHj5PyOs0Djg_x20LosqHHh35xw",
  authDomain: "symposium-de515.firebaseapp.com",
  databaseURL:"gs://symposium-de515.appspot.com",
  projectId: "symposium-de515",
  storageBucket: "symposium-de515.appspot.com",
  messagingSenderId: "264796869147",
  appId: "1:264796869147:web:0376ef6064fe5a47fb5ebe"
};

firebase.initializeApp(firebaseConfig);

function Registerimage() {
  const navigate = useNavigate();

  const onFinish = (values) => {
    console.log('Form values:', values);
  };

  const [name, setName] = useState('');
  const [degree, setDegree] = useState('');
  const [year, setYear] = useState('');
  const [college_name, setCollegeName] = useState('');
  const [mail, setMail] = useState('');
  const [mobnumber, setMobileNumber] = useState('');
  const [food, setFood] = useState('');
  const [gender, setGender] = useState('');
  const [idCard, setIdCard] = useState(null);
  const [selectedDate, setSelectedDate] = useState('');
  const [department, setDepartment] = useState('');
  const [selectedEvents, setSelectedEvents] = useState([]);
  const [loading,setLoading] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});


  const handleSubmit = async (e) => {
    e.preventDefault();
    if(loading) return;
    setLoading(true)

    const errorMessages = {};

    
    if (!name) errorMessages.name = 'Please enter your Name!';
    if (!degree) errorMessages.degree = 'Please enter your Degree!';
    if (!year) errorMessages.year = 'Please enter your Year!';
    if (!college_name) errorMessages.college_name = 'Please enter your College Name!';
    if (!mail) errorMessages.mail = 'Please enter your Mail!';
    if (!mobnumber) errorMessages.mobnumber = 'Please enter your Mobile Number!';
    if (!food) errorMessages.food = 'Please select your Food Preference';
    if (!gender) errorMessages.gender = 'Please select your Gender';
    if (!idCard) errorMessages.idCard = 'Please upload your ID Card';
    if (!selectedDate) errorMessages.selectedDate = 'Please select a Date';
    if (!department) errorMessages.department = 'Please select your Department';
    if (selectedEvents.length === 0) errorMessages.selectedEvents = 'Please select at least one Event';

    
    setFieldErrors(errorMessages);

    
    if (Object.keys(errorMessages).length > 0) {
      
      message.error('Please fill in all the required details.');
      setLoading(false);
      return;
    }

    

    const storageRef = firebase.storage().ref();
    const idCardRef = storageRef.child(idCard.name);

    try {
      const snapshot = await idCardRef.put(idCard);
      const downloadURL = await snapshot.ref.getDownloadURL();

      const data = {
        Name: name,
        Degree: degree,
        Year: year,
        College: college_name,
        Mail: mail,
        Contact: mobnumber,
        Food: food.toString(),
        Gender: gender.toString(),
        Department: department,
        
        IDCardURL: downloadURL,
        Timestamp: new Date().toString(), 
        Events: selectedEvents.join(','),
      };
      
      //   const response1 = await axios.post(
      //     'https://sheet.best/api/sheets/52033d54-c338-4d08-8db1-463e0a4a1ed9',
      //     data
      // );
    

      const response =  axios.post(
        `https://symposium-de515-default-rtdb.firebaseio.com/${department}.json`,
        data
      );
      console.log(response);

      
      

      const sheetTabId = getSheetTabIdByDepartment(department); 
       fetch(`https://v1.nocodeapi.com/prash/google_sheets/YmgdLsFGcBVTrOhk?tabId=${sheetTabId}`, {
        //https://v1.nocodeapi.com/nandha/google_sheets/eCLaUHCSfsjvOiLI?tabId=${sheetTabId}
        //https://v1.nocodeapi.com/cryptrix/google_sheets/XHePNjXFGLzRMlPP?tabId=${sheetTabId}
        //https://v1.nocodeapi.com/kishore1803/google_sheets/zDOFLYoqyGrKyQcV?tabId=${sheetTabId}
        //https://v1.nocodeapi.com/cryptrix/google_sheets/IMTMAyQwnfXkHzfA?tabId=${sheetTabId}
        //https://v1.nocodeapi.com/sudhir/google_sheets/GHlEFPFYowfwZJCR?tabId=${sheetTabId}
        //https://symposium-7cf30-default-rtdb.firebaseio.com?tabId=${sheetTabId}
        //https://v1.nocodeapi.com/kabilaaa/google_sheets/VyFbMfBctcGAsDxL?tabId=${sheetTabId}
        //https://v1.nocodeapi.com/sympo/google_sheets/hyHPvGvSmDUHGVLL?tabId=${sheetTabId}
        //https://v1.nocodeapi.com/sugarbrownies/google_sheets/hsreMBqjLgMKdYGa?tabId=${sheetTabId}
        //https://v1.nocodeapi.com/symposium/google_sheets/AsfYITbRfTUIxHed?tabId=${sheetTabId}
        //https://v1.nocodeapi.com/registration/google_sheets/gsVVxUdaUAJnQSQW?tabId=${sheetTabId}
        //https://v1.nocodeapi.com/prash/google_sheets/YmgdLsFGcBVTrOhk?tabId=${sheetTabId}

        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify([Object.values(data)]),
      });

      console.log('Data appended to Google Sheet successfully');
      message.success('Registration Successful', 5, () => {
        navigate('/thankyou.html');
      });
      
    } catch (error) {
      console.log(error);
      
    }
    const data = {
      
      Mail: mail,
      Department: department,
      Name:name,
      
    };
    const mail_id = await axios.get(
      `https://email-automation-sample.vercel.app/send/mail/${mail}/${department}/${name}`,data
    );
  };
  
  

  const handleIdCardChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size <= 1024 * 1024) {
      setIdCard(file);
      
      setFieldErrors((prevState) => ({
        ...prevState,
        idCard: '',
      }));
    } else {
     
      setFieldErrors((prevState) => ({
        ...prevState,
        idCard: 'Please upload an image below 1 MB',
      }));
    }
  };

  const handleDateChange = (value) => {
    setSelectedDate(value);
    setDepartment('');
    
  };

  const getSheetTabIdByDepartment = (department) => {
    
    const departmentSheetMap = {
      CSE: 'CSE',
      IT: 'IT',
      EEE: 'EEE',
      ECE: 'ECE',
      MECH: 'MECH',
      CIVIL: 'CIVIL',
      CHEMICAL: 'CHEMICAL',
      MBA: 'MBA',
      MATHS: 'MATHS',
      EIE: 'EIE',
      BIOTECH:'BIOTECH'
    };

    return departmentSheetMap[department];
  };

  const renderDepartmentOptions = () => {
    if (selectedDate === '5/8/23') {
      return (
        <>
          <Option value="CSE">CSE & ADS</Option>
          <Option value="EEE">EEE</Option>
          <Option value="ECE">ECE</Option>
          <Option value="CIVIL">CIVIL</Option>
          <Option value ="BIOTECH">BIOTECH</Option>
        </>
      );
    } else if (selectedDate === '2/9/23') {
      return (
        <>
          <Option value="MBA">MBA</Option>
          <Option value="MECH">MECH</Option>
          <Option value="IT">IT & AML</Option>
          <Option value="MATHS">MATHS</Option>
          <Option value="CHEMICAL">CHEMICAL</Option>
          <Option value="EIE">EIE & ICE</Option>
        </>
      );
    } else {
      return null;
    }


  };


  const renderEventOptions = () => {
    if (department === 'CSE') {
      return (
        <>
          <Option value="Data Forge">Data Forge</Option>
          <Option value="Hyper Hurdle">Hyper Hurdle</Option>
          <Option value="CSS Battle">CSS Battle</Option>
          <Option value="Cyberquest">Cyberquest</Option>
          <Option value="Relay Coding">Relay Coding</Option>
        </>
      );
    } else if (department === 'EEE') {
      return (
        <>
          <Option value="E-Talash">E-Talash</Option>
          <Option value="Circutrix">Circutrix</Option>
          <Option value="Technical Quiz">Technical Quiz</Option>
          <Option value="Tech-charades">Tech-charades</Option>
          <Option value="Ted Talks">Ted Talks</Option>
        </>
      );
  
    } else if (department === 'ECE') {
      return (
        <>
          <Option value="Graph-ITI">Graph-ITI</Option>
          <Option value="Idea Auction">Idea Auction</Option>
          <Option value="Sherlock Holmes">Sherlock Holmes</Option>
          <Option value="Ad Surfing">Ad Surfing</Option>
          <Option value="Shock and ladder">Shock and ladder</Option>
        </>
      );
  
    } else if (department === 'CIVIL') {
      return (
        <>
          <Option value="Tech-conx">Tech-conx</Option>
          <Option value="Envision">Envision</Option>
          <Option value="Poke ur Brain">Poke ur Brain</Option>
          <Option value="Decryption">Decryption</Option>
          <Option value="Vision Quest">Vision Quest</Option>
        </>
      );

    } else if (department === 'BIOTECH') {
      return (
        <>
          <Option value="Gene x Hunter">Gene x Hunter</Option>
          <Option value="Crime chronicles">Crime chronicles</Option>
          <Option value="Bioscales and DNA Trials">Bioscales and DNA Trials</Option>
          <Option value="Endless chaos">Endless chaos</Option>
          <Option value="Grey Matter">Grey Matter</Option>
        </>
      );
     
    } else if (department === 'MBA') {
      return (
        <>
          <Option value="Business Quiz">Business Quiz</Option>
          <Option value="OMG!!">OMG!!</Option>
          <Option value="Ad-Zap">Ad-Zap</Option>
          <Option value="Best Manager">Best Manager</Option>
          <Option value="Stock Wars">Stock Wars</Option>
        </>
      );
      
    } else if (department === 'MECH') {
      return (
        <>
          <Option value="Auto Quiz">Auto Quiz</Option>
          <Option value="Budding Dsigner">Budding Dsigner</Option>
          <Option value="Water Rocketry">Water Rocketry</Option>
          <Option value="Just in Time">Just in Time</Option>
          <Option value="Tech war">Tech war</Option>
        </>
      );

    } else if (department === 'IT') {
      return (
        <>
          <Option value="Techflix">Techflix</Option>
          <Option value="Trio Developers">Trio Developers</Option>
          <Option value="Innosquad Challenge">Innosquad Challenge</Option>
          <Option value="Technotrails">Technotrails</Option>
          <Option value="Snippet shuffle">Snippet shuffle</Option>
        </>
      );
   
    } else if (department === 'MATHS') {
      return (
        <>
          <Option value="Vanquishers">Vanquishers</Option>
          <Option value="Limit Breakers">Limit Breakers</Option>
          <Option value="Infinity Nation">Infinity Nation</Option>
          <Option value="Number Ninjas">Number Ninjas</Option>
          <Option value="Cross country survivor">Cross country survivor</Option>
        </>
      );
      
    } else if (department === 'CHEMICAL') {
      return (
        <>
          <Option value="Chemriddle">Chemriddle</Option>
          <Option value="chem carnival">chem carnival</Option>
          <Option value="ChemECipher">ChemECipher</Option>
          <Option value="Quick-o-Chem">Quick-o-Chem</Option>
          <Option value="Alchemy">Alchemy</Option>
        </>
      );
     
    } else if (department === 'EIE') {
      return (
        <>
          <Option value="Intellecta">Intellecta</Option>
          <Option value="Dedugon">Dedugon</Option>
          <Option value="Techno Expendition">Techno Expendition</Option>
          <Option value="Nexus Fusion">Nexus Fusion</Option>
          <Option value="Volt Rush">Volt Rush</Option>
        </>
      );
    
    } else {
      return null;
    }
  };

  return (
    <div className="appbg">
      <Form className="login" onFinish={onFinish}>
        <Typography.Title>Register Here</Typography.Title>

        <div className="form-item">
          <lable className="label">Enter your name:</lable>

          <Form.Item name="name" rules={[{ required: true, message: 'Please enter your Name!' }]}>
            <Input onChange={(e) => setName(e.target.value)} value={name} />
          </Form.Item>
        </div>

        <div className="form-item">
          <lable className="label">Degree and Branch:</lable>
          <Form.Item
            name="degree"
            rules={[{ required: true, message: 'Please enter your Degree!' }]}
          >
            <Input onChange={(e) => setDegree(e.target.value)} value={degree} />
          </Form.Item>
        </div>

        <div className="form-item">
          <lable className="label">Year:</lable>
          <Form.Item name="year" rules={[{ required: true, message: 'Please enter your Year!' }]}>
            <Input onChange={(e) => setYear(e.target.value)} value={year} />
          </Form.Item>
        </div>

        <div className="form-item">
          <lable className="label">College Name:</lable>
          <Form.Item
            name="college_name"
            rules={[{ required: true, message: 'Please enter your College Name!' }]}
          >
            <Input onChange={(e) => setCollegeName(e.target.value)} value={college_name} />
          </Form.Item>
        </div>

        <div className="form-item">
          <lable className="label">Mail:</lable>
          <Form.Item name="mail" rules={[{ required: true, message: 'Please enter your Mail!' }]}>
            <Input onChange={(e) => setMail(e.target.value)} value={mail} />
          </Form.Item>
        </div>

        <div className="form-item">
          <lable className="label">Mobile Number:</lable>
          <Form.Item
            name="mobnumber"
            rules={[{ required: true, message: 'Please enter your Mobile Number!' }]}
          >
            <Input onChange={(e) => setMobileNumber(e.target.value)} value={mobnumber} />
          </Form.Item>
        </div>

        <div className="form-item">
          <lable className="label">Food Preference:</lable>
          <Form.Item
            name="food"
            rules={[{ required: true, message: 'Please select your Food Preference' }]}
          >
            <Select
              placeholder="Select Food Preference"
              onChange={(value) => setFood(value)}
              value={food}
            >
              <Option value="Veg">Veg</Option>
              <Option value="Non-Veg">Non-Veg</Option>
            </Select>
          </Form.Item>
        </div>

        <div className="form-item">
          <lable className="label">Gender:</lable>
          <Form.Item
            name="gender"
            rules={[{ required: true, message: 'Please select your Gender' }]}
          >
            <Select
              placeholder="Select Gender"
              onChange={(value) => setGender(value)}
              value={gender}
            >
              <Option value="Male">Male</Option>
              <Option value="Female">Female</Option>
            </Select>
          </Form.Item>
        </div>

        <div className="form-item">
          <lable className="label">ID Card:</lable>
          <Form.Item name="idCard" rules={[{ required: true, message: 'Please upload your ID Card' }]}>
            <Input type="file" onChange={handleIdCardChange} />
          </Form.Item>
          {fieldErrors.idCard && <span style={{ color: 'red' }}>{fieldErrors.idCard}</span>}
        </div>

        <div className="form-item">
          <lable className="label">Date:</lable>
          <Form.Item
            name="date"
            rules={[{ required: true, message: 'Please select a Date' }]}
          >
            <Select placeholder="Select Date" onChange={handleDateChange} value={selectedDate}>
              {/* <Option value="5/8/23">5/8/23</Option> */}
              {/* <Option value="2/9/23">2/9/23</Option> */}
            </Select>
          </Form.Item>
        </div>

        <div className="form-item">
          <lable className="label">Department:</lable>
          <Form.Item
            name="department"
            rules={[{ required: true, message: 'Please select your Department' }]}
          >
            <Select
              placeholder="Select Department"
              onChange={(value) => setDepartment(value)}
              value={department}
            >
              {renderDepartmentOptions()}
            </Select>
          </Form.Item>
        </div>

        {department && (
          <div className="form-item">
            <lable className="label">Events:</lable>
            <Form.Item
              name="events"
              rules={[{ required: true, message: 'Please select events' }]}
            >
              <Select
                mode="multiple"
                placeholder="Select any 3 Events"
                onChange={(values) => setSelectedEvents(values)}
                value={selectedEvents}
              >
                {renderEventOptions()}
              </Select>
            </Form.Item>
          </div>
        )}

        <Divider />

        <Button type="primary" htmlType="submit" onClick={handleSubmit}>
          {loading ? 'Loading':"Register"}
          
        </Button>
      </Form>
    </div>
  );
}

export default Registerimage;